import styled from "styled-components";

export const SwitchContainer = styled.div`
  display: flex;
  padding: 4px 6px;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  min-width: 130px;
  height: 32px;
  justify-content: space-between;
  border: 1px solid var(--primary-dark-200);
  color: var(--primary-blue);
  font-size: var(--fs-base);
  line-height: var(--lh-base);
`;

export const IconContainer = styled.div`
  cursor: pointer;
  display: flex;
`;
